import { useSelector } from 'react-redux';
import { AlertsTabIcon } from '@rsos/assets/icons';
import { ActionBarItem } from '../ActionBarItem';

const AlertsActionBarItem = ({ onClick, hasAlertsAccess }) => {
  const isCollapsed = useSelector(state => state.queue?.isQueueCollapsed);

  return (
    <ActionBarItem
      shouldRender={isCollapsed && hasAlertsAccess}
      tooltipText="Alerts"
      onClick={onClick}
      color="states"
    >
      <AlertsTabIcon height={16} width={16} />
      Alerts
    </ActionBarItem>
  );
};

export default AlertsActionBarItem;
